import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import { dimensions } from "@styles";

import ClerkBackground from "./assets/ClerkDashboardBackground.jpg";
import SubPracBackground from "./assets/SubPracDashboardBackground.jpg";

export const background = (theme: Theme) => css`
  height: 100vh;
  background-color: ${theme.system.backgroundMuted};
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: ${dimensions.desktopMax}) {
    background-position: 15% center;
  }
`;

export const clerkBackground = css`
  background-image: url("${ClerkBackground}");
`;

export const subPracBackground = css`
  background-image: url("${SubPracBackground}");
`;
